import { render } from "./Aanmelding.vue?vue&type=template&id=31dc91e0&scoped=true"
import script from "./Aanmelding.vue?vue&type=script&lang=js"
export * from "./Aanmelding.vue?vue&type=script&lang=js"

import "./Aanmelding.vue?vue&type=style&index=0&id=31dc91e0&scoped=true&lang=css"

import exportComponent from "/Users/vincent/Documents/GIT_CLONES/skipiste/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31dc91e0"]])

export default __exports__